"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const SummaryData_1 = __importDefault(require("../entity/SummaryData"));
const SummaryStub_1 = __importDefault(require("./SummaryStub"));
class SummaryDataStub extends SummaryData_1.default {
    constructor({ label = '2019/11', sales = new SummaryStub_1.default(), visitors = new SummaryStub_1.default(), salesByVisitors = new SummaryStub_1.default(), purchaseRates = new SummaryStub_1.default(), purchasers = new SummaryStub_1.default(), visitorsBySession = new SummaryStub_1.default(), visitorsByPv = new SummaryStub_1.default(), } = {}) {
        super({
            label,
            sales,
            visitors,
            salesByVisitors,
            purchaseRates,
            purchasers,
            visitorsBySession,
            visitorsByPv,
        });
    }
}
exports.default = SummaryDataStub;
